import { Star } from "lucide-react";

export const Stars = ({ value, size = 16 }) => (
  <span className="flex gap-0.5" aria-label={`${value} stelle su 5`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} size={size} className={n <= value ? "fill-amber-400 text-amber-400" : "text-slate-300"} />
    ))}
  </span>
);
